import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ErrorMessage,
  Field,
  FieldArray,
  Formik,
  Form as FormikForm,
} from "formik";
import { ContentState, EditorState, convertToHTML } from "draft-js";
import {
  userDetail,
  userUpdate,
  userSelectUser,
  selectedTeamLead,
  selectedMentor,
  selectedCoach,
  searchUser,
  userDetailBroker,
  getLicensedAs,
  fetchTimezoneArray,
  userUpdateClear,
  UserRoleRequestStatus,
  UserRoleRequestStatusClear,
  fetchTimezoneAbbr,
  getProvinceMasterData,
  getProvinceMasterDataClear,
  userDetailBrokerForOther,
  getCityList,
  getLanguages,
  getLanguagesClear,
} from "../../redux/user/actions";
import {
  clickStreamUser,
  dateTimeStamp,
  SessionKeys,
} from "../../utils/AppUtils";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ConfirmModal from "../modal/ConfirmModal";
import _ from "lodash";
import Loader from "../Loader/Loader";
import CONFIG from "../../utils/config";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { t } from "i18next";
import { getAllSkills, getAllSkillsClear } from "../../redux/coaching/actions";
import Select from "react-select";
import RichTextEditor from "../../pages/RichTextEditor";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { getFileUploadOnAWS } from "../../redux/events/actions";
import SimplePopup from "../modal/SimplePopup";
import "../../pages/GroupWorkshop/GroupWorkShop.scss";
import htmlToDraft from "html-to-draftjs";
import { countryDatas } from "../../utils/StaticData";
const ProfilEdit = (props) => {
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.user.role);
  const auth = useSelector((state) => state.auth.auth);
  const authBroker = useSelector((state) => state.auth.authBroker);
  // const userDetailRes = useSelector(state => state.user.user)
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailResForOther = useSelector(
    (state) => state.user.userBrokerForOther
  );
  const licensedAsRes = useSelector((state) => state.user.licensedAsRes);
  const userUpdateRes = useSelector((state) => state.user.userUpdateRes);
  const searchUserRes = useSelector((state) => state.user.searchUserRes);
  const provinceMaster = useSelector((state) => state.user.provinceMaster);
  // const teamLead = useSelector(state => state.user.selectedTeamLead)
  // const mentor = useSelector(state => state.user.selectedMentor)
  // const coach = useSelector(state => state.user.selectedCoach)
  const [isHost, setIsHost] = useState(
    userRole === "instructor" || userRole === "host"
  );
  const [isGuest, setIsGuest] = useState(false);
  const [teamLead, setTeamLead] = useState("");
  const [mentor, setMentor] = useState("");
  const [coach, setCoach] = useState("");
  const timezoneArray = useSelector((state) => state.user.timezoneMaster);
  const usersOfRoleAcceptanceStatus = useSelector(
    (state) => state.user.UserRoleRequestStatus
  );
  const [teamLeadInput, setTeamLeadInput] = useState("");
  const [mentorInput, setMentorInput] = useState("");
  const [coachInput, setCoachInput] = useState("");
  const [degn, setDegn] = useState("");
  const [timezone, setTimezone] = useState("");
  const [users, setUsers] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isTeamLeadError, setIsTeamLeadError] = useState("");
  const [isMentorError, setIsMentorError] = useState("");
  const [isCoachError, setIsCoachError] = useState("");
  const [isTimeZoneError, setIsTimezoneError] = useState("");
  const [licensedAs, setLicensedAs] = useState([]);
  const [timezoneList, setTimezoneList] = useState([]);
  const [currentRole, setCurrentRole] = useState(0);
  const [selectedCoachStatus, setSelectedCoachStatus] = useState("");
  const [selectedMentorStatus, setSelectedMentorStatus] = useState("");
  const [selectedTeamLeadStatus, setSelectedTeamLeadStatus] = useState("");
  const [pfexp, setPfexp] = useState("");
  const [programsOfferedVal, setProgramsOfferedVal] = useState("");
  const [selectedCoachName, setSelectedCoachName] = useState("");
  const [selectedMentorName, setSelectedMentorName] = useState("");
  const [selectedTeamLeadName, setSelectedTeamLeadName] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState([]);
  const [requestedCoachId, setRequestedCoachId] = useState("");
  const [requestedMentorId, setRequestedMentorId] = useState("");
  const [requestedTeamLeadId, setRequestedTeamLeadId] = useState("");
  const [designation, setDesignation] = useState("");

  const [rejectReasonCoach, setRejectReasonCoach] = useState("");
  const [rejectReasonMentor, setRejectReasonMentor] = useState("");
  const [rejectReasonTeamLead, setRejectReasonTeamLead] = useState("");

  const [userRoleAccessStatus, setUserRoleAccessStatus] = useState([]);
  const [recoData, setRecoData] = useState("");

  const [firstName, setFirstName] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [provinceList, setProvinceList] = useState([]);

  const [isLoading, setIsLoading] = useState();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const user_id = params.get("user_id");
  const isOther = "0"; //localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1";

  const [skillsList, setSkillsList] = useState([]);
  const [skillsSet, setSkillsSet] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [aoeList, setAoeList] = useState([]);
  const [aoeSet, setAoeSet] = useState([]);
  const [selectedAoe, setSelectedAoe] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [industry, setIndustry] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState("");
  const [selectedNotificationLang, setSelectedNotificationLang] = useState("");
  const [professionalExperience, setProfessionalExperience] = useState(
    EditorState.createEmpty()
  );
  const [bioInfo, setBioInfo] = useState(EditorState.createEmpty());
  const [coursesOffered, setCoursesOffered] = useState(
    EditorState.createEmpty()
  );
  const [profExpPlain, setProfExpPlain] = useState("");
  const [coursesOfferedPlain, setCoursesOfferedPlain] = useState("");
  const [ccDocs, setCcDocs] = useState([]);
  const [isCcDocLoading, setIsCcDocLoading] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const [error, setError] = useState("");
  const [updatedBio, setUpdatedBio] = useState("");
  const [linkdin, setlinkdin] = useState("");
  const [xlink, setXlink] = useState("");
  const [country, setCountry] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [defaultValue, setDefaultValue] = useState([]);
  const [defaultLangValue, setDefaultLangValue] = useState([]);
  const [defaultExpertiseValue, setDefaultExpertiseValue] = useState([]);
  const [citiesData, setCitiesData] = useState([]);
  const [languagesList, setLanguagesList] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  //    params.get("isOther");
  const coachingStore = useSelector((state) => state.coaching.skillsList);
  const citiesList = useSelector((state) => state.user.getCitiesList);
  const metaLanguages = useSelector((state) => state.user.getLanguagesList);
  const [linkedProfilLinkError, setLinkedProfilLinkError] = useState("");
  const [xProfilLinkError, setXProfilLinkError] = useState("");
  const [experience, setExperience] = useState([
    {
      label: "Fresher (0-1 year)",
      value: "Fresher (0-1 year)",
    },
    { label: "1 year", value: "1 year" },
    { label: "2 years", value: "2 years" },
    { label: "3 years", value: "3 years" },
    { label: "4 years", value: "4 years" },
    { label: "5 years", value: "5 years" },
    { label: "6 years", value: "6 years" },
    { label: "7 years", value: "7 years" },
    { label: "8 years", value: "8 years" },
    { label: "9 years", value: "9 years" },
    { label: "10 years", value: "10 years" },
    { label: "11 years", value: "11 years" },
    { label: "12 years", value: "12 years" },
    { label: "13 years", value: "13 years" },
    { label: "14 years", value: "14 years" },
    { label: "15 years", value: "15 years" },
    { label: "16 years", value: "16 years" },
    { label: "17 years", value: "17 years" },
    { label: "18 years", value: "18 years" },
    { label: "19 years", value: "19 years" },
    { label: "20 years", value: "20 years" },
    { label: "21 years", value: "21 years" },
    { label: "22 years", value: "22 years" },
    { label: "23 years", value: "23 years" },
    { label: "24 years", value: "24 years" },
    { label: "25 years", value: "25 years" },
    { label: "26 years", value: "26 years" },
    { label: "27 years", value: "27 years" },
    { label: "28 years", value: "28 years" },
    { label: "29 years", value: "29 years" },
    { label: "30 years", value: "30 years" },
  ]);
  useEffect(() => {
    console.log("coachingStore", coachingStore);
    if (!_.isEmpty(coachingStore)) {
      if (coachingStore?.status === "success") {
        setIndustry(coachingStore?.payload?.payload?.industry);

        let list = coachingStore?.payload?.payload?.skill;
        setSkillsSet(list);
        setSkillsList(
          _.map(list, (skill) => {
            return {
              value: skill?.id,
              label: skill?.name,
            };
          })
        );
        let aoeList = coachingStore?.payload?.payload?.expertise;
        setAoeSet(aoeList);
        setAoeList(
          _.map(aoeList, (expertise) => {
            return {
              value: expertise?.id,
              label: expertise?.name,
            };
          })
        );
        setIsLoading(false);
      } else {
        setSkillsList([]);
        setAoeList([]);
        setIsLoading(false);
      }
    }
  }, [coachingStore]);

  useEffect(() => {
    console.log("check12---", availabilityFilter);
  }, [availabilityFilter]);
  useEffect(() => {
    console.log("cities-", citiesList);
    if (!_.isEmpty(citiesList)) {
      if (citiesList?.status === "success") {
        let list = citiesList?.payload?.payload?.city?.map((item) => ({
          value: item.id,
          label: item.city,
        }));
        setCitiesData(list);
        setIsLoading(false);
      } else {
        setCitiesData([]);
        setIsLoading(false);
      }
    }
  }, [citiesList]);

  useEffect(() => {
    if (!_.isEmpty(country)) {
      const countryObj = countryDatas.find((obj) => obj.id === country);
      setProvinceList(countryObj?.provience);
    }
  }, [country]);

  const [languageSet, setLanguageSet] = useState([]);
  useEffect(() => {
    console.log("languages-", metaLanguages);
    if (!_.isEmpty(metaLanguages)) {
      if (metaLanguages?.status === "success") {
        setLanguageSet(metaLanguages?.payload?.payload);
        let list = metaLanguages?.payload?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setLanguagesList(list);
        setIsLoading(false);
      } else {
        setLanguagesList([]);
        setIsLoading(false);
      }
    }
  }, [metaLanguages]);

  const getAllSkillsAPI = () => {
    // setIsLoading(true);
    // dispatch(
    //   getAllSkills({
    //     module: "getAllSkills",
    //     token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //   })
    // );
  };

  const getCitiesAPI = () => {
    setIsLoading(true);
    dispatch(
      getCityList({
        module: "getCities",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  const getLanguagesAPI = () => {
    // setIsLoading(true);
    // dispatch(
    //   getLanguages({
    //     module: "getLanguages",
    //     postData: {
    //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //     },
    //   })
    // );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllSkillsAPI();
    // getCitiesAPI();
    getLanguagesAPI();
    return () => {
      dispatch(getAllSkillsClear());
      dispatch(getLanguagesClear());
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // dispatch(
    //   getProvinceMasterData({
    //     module: "getProvinceMaster",
    //     postData: {},
    //   })
    // );
  }, [dispatch]);
  useEffect(() => {
    if (!_.isEmpty(provinceMaster)) {
      if (provinceMaster.status === "success") {
        const plist = provinceMaster.payload.payload;
        if (!_.isEmpty(plist)) {
          // setProvinceList(plist);
        }
      }
      dispatch(getProvinceMasterDataClear());
    }
  }, [provinceMaster]);
  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      console.log("authBroker: ", authBroker, auth);
      if (!_.isEmpty(authBroker.payload.user.role)) {
        setIsGuest(authBroker.payload.user.role.includes("guest"));
      }
    }
  }, [authBroker]);

  useEffect(() => {
    let userDetailResLocal =
      isOther === "1" ? userDetailResForOther : userDetailRes;

    if (
      !_.isEmpty(userDetailResLocal) &&
      !_.isEmpty(timezoneArray)
    ) {
      setIsLoading(false);
    }
  }, [userDetailRes, userDetailResForOther, timezoneArray, licensedAsRes]);

  const getUserDetail = () => {
    if (isOther === "1") {
      setIsEdit(false);
      dispatch(
        userDetailBrokerForOther({
          module: "getUserDetailBrokerForOther",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_user_id: user_id,
          },
        })
      );
    } else {
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          userId: authBroker?.payload?.user?.user_id
        })
      );
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getUserDetail();

    dispatch(
      fetchTimezoneArray({
        module: "getTimezone",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
        },
      })
    );

    // dispatch(
    //   getLicensedAs({
    //     module: "getLicensedAs",
    //     postData: {},
    //   })
    // );
  }, [dispatch, user_id]);

  useEffect(() => {
    // console.log('licensedAsRes: ', licensedAsRes)
    if (licensedAsRes?.status === "success") {
      setLicensedAs(licensedAsRes.payload.payload);
    }
  }, [licensedAsRes]);

  useEffect(() => {
    let userDetailResLocal =
      isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(licensedAs) && !_.isEmpty(userDetailResLocal)) {
      licensedAs.map((cat) => {
        if (userDetailResLocal?.payload?.payload?.degn === cat.designation) {
          setRecoData(cat.designation);
        }
      });
    }
  }, [licensedAs, userDetailRes, userDetailResForOther]);

  useEffect(() => {
    if (!_.isEmpty(timezoneArray)) {
      if (timezoneArray.status === "success") {
        let list = timezoneArray.payload.payload.map((item) => ({
          value: item.id,
          label: `${item.abbreviations} (${item.offset})`,
        }));
        setTimezoneList(list);
      } else {
        setTimezoneList([]);
      }
    }
  }, [timezoneArray]);

  useEffect(() => {
    if (!confirmModal) {
      setConfirmModal(false);
    }
  }, [confirmModal]);

  useEffect(() => {
    let userDetailResLocal =
      isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal.status === "success") {
        setFirstName(userDetailResLocal?.payload?.payload?.firstname);
        setCity(userDetailResLocal?.payload?.payload?.office_city);

        setTeamLead(userDetailResLocal?.payload?.payload?.team_lead_id);
        setMentor(userDetailResLocal?.payload?.payload?.mentor_id);
        setCoach(userDetailResLocal?.payload?.payload?.coach_id);
        setTeamLeadInput(
          userDetailResLocal?.payload?.payload?.team_lead === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.team_lead
        );
        setMentorInput(
          userDetailResLocal?.payload?.payload?.mentor === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.mentor
        );
        setCoachInput(
          userDetailResLocal?.payload?.payload?.coach === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.coach
        );
        setDegn(
          userDetailResLocal?.payload?.payload?.degn === " "
            ? ""
            : userDetailResLocal?.payload?.payload?.degn
        );
        setTimezone(
          userDetailResLocal.payload?.payload?.timezone_id === ""
            ? ""
            : userDetailResLocal?.payload?.payload?.timezone_id
        );
        getRoleReqStatus();

        if (!_.isEmpty(userDetailResLocal?.payload?.payload)) {
          dispatch(
            fetchTimezoneAbbr(userDetailResLocal.payload.payload.timezone)
          );
        }
      }
      setCountry(
        userDetailResLocal.payload?.payload?.country === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.country
      );

      setProvince(
        userDetailResLocal.payload?.payload?.province === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.province
      );

      if (_.isEmpty(userDetailResLocal.payload?.payload?.country)) {
        // setCountry(countryDatas[0]?.id);
        // setProvince(countryDatas[0]?.provience[0]?.id);
        setProvinceList(countryDatas[0]?.provience);
      }

      if (userDetailResLocal.payload?.payload?.coach_info?.bio) {
        const contentBlock = htmlToDraft(
          userDetailResLocal?.payload?.payload?.coach_info?.bio
        );
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
          contentBlock.entityMap
        );
        setBioInfo(EditorState.createWithContent(contentState));
      }
      setUpdatedBio(
        userDetailResLocal.payload?.payload?.coach_info?.bio === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.bio
      );
      setCcDocs(
        _.isEmpty(
          userDetailResLocal.payload?.payload?.coach_info?.certifications
        )
          ? []
          : userDetailResLocal?.payload?.payload?.coach_info?.certifications
      );
      setAvailabilityFilter(
        _.isEmpty(userDetailResLocal.payload?.payload?.coach_info?.availability)
          ? []
          : userDetailResLocal?.payload?.payload?.coach_info?.availability
      );
      setXlink(
        userDetailResLocal.payload?.payload?.coach_info?.x_link === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.x_link
      );
      setlinkdin(
        userDetailResLocal.payload?.payload?.coach_info?.linkedin === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.linkedin
      );

      setDesignation(
        userDetailResLocal.payload?.payload?.coach_info?.designation === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.designation
      );

      setSelectedExperience(
        userDetailResLocal.payload?.payload?.coach_info?.experience === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.experience
      );
      setSelectedNotificationLang(
        userDetailResLocal.payload?.payload?.notification_language === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.notification_language
      );
      setSelectedIndustry(
        _.isEmpty(userDetailResLocal.payload?.payload?.coach_info?.industry)
          ? ""
          : userDetailResLocal?.payload?.payload?.coach_info?.industry?.id
      );
      let skills = _.isEmpty(
        userDetailResLocal.payload?.payload?.coach_info?.skill_array
      )
        ? []
        : userDetailResLocal?.payload?.payload?.coach_info?.skill_array;
      const newDefaultValue = _.map(skills, (course) => {
        return {
          value: course?.id,
          label: course?.name,
        };
      });

      let expertise = _.isEmpty(
        userDetailResLocal.payload?.payload?.coach_info?.expertise
      )
        ? []
        : userDetailResLocal?.payload?.payload?.coach_info?.expertise;
      const newDefaultExpertiseValue = _.map(expertise, (course) => {
        return {
          value: course?.id,
          label: course?.name,
        };
      });

      let lang = _.isEmpty(
        userDetailResLocal.payload?.payload?.coach_info?.language
      )
        ? []
        : userDetailResLocal?.payload?.payload?.coach_info?.language;
      const defaultLangSet = _.map(lang, (course) => {
        return {
          value: course?.id,
          label: course?.name,
        };
      });

      setDefaultValue(newDefaultValue);
      setDefaultExpertiseValue(newDefaultExpertiseValue);
      setDefaultLangValue(defaultLangSet);
      setSelectedLanguage(
        userDetailResLocal.payload?.payload?.language_id === ""
          ? ""
          : userDetailResLocal?.payload?.payload?.language_id
      );

      if (
        userDetailResLocal?.payload?.payload?.coach_info
          ?.professional_experience
      ) {
        const contentBlock = htmlToDraft(
          userDetailResLocal?.payload?.payload?.coach_info
            ?.professional_experience
        );
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
          contentBlock.entityMap
        );
        setProfessionalExperience(EditorState.createWithContent(contentState));
        setProfExpPlain(
          userDetailResLocal?.payload?.payload?.coach_info
            ?.professional_experience
        );
        const contentBlock1 = htmlToDraft(
          userDetailResLocal?.payload?.payload?.coach_info?.program_offered
        );
        const contentState1 = ContentState.createFromBlockArray(
          contentBlock1.contentBlocks,
          contentBlock1.entityMap
        );
        setCoursesOffered(EditorState.createWithContent(contentState1));
      } else {
        setCoursesOffered(EditorState.createEmpty());
      }
      setCoursesOfferedPlain(
        userDetailResLocal?.payload?.payload?.coach_info?.program_offered
      );
    }
  }, [userDetailRes, userDetailResForOther]);

  useEffect(() => {
    const newDefaultValue = _.map(selectedSkills, (course) => {
      return {
        value: course?.id,
        label: course?.name,
      };
    });

    setDefaultValue(newDefaultValue);
  }, [selectedSkills]);

  useEffect(() => {
    const newDefaultValue = _.map(selectedAoe, (course) => {
      return {
        value: course?.id,
        label: course?.name,
      };
    });

    setDefaultExpertiseValue(newDefaultValue);
  }, [selectedAoe]);
  useEffect(() => {
    const newDefaultValue = _.map(selectedLanguage, (course) => {
      return {
        value: course?.id,
        label: course?.name,
      };
    });

    setDefaultLangValue(newDefaultValue);
  }, [selectedLanguage]);

  useEffect(() => {
    if (!_.isEmpty(userUpdateRes)) {
      if (userUpdateRes?.status === "success") {
        getUserDetail();
        setShowModalMsg(t("Profile updated successfully."));
      } else {
        setShowModalMsg(t("Error updating profile."));
      }
      setConfirmModal(true);
      setIsConfirm(false);
      dispatch(userUpdateClear());
      setIsLoading(false);
      window.scrollTo(0, 0);
    }
  }, [userUpdateRes]);

  useEffect(() => {
    // console.log('userDetailRes111searchUserRes: ', searchUserRes)
    if (searchUserRes?.status === "success") {
      const persons = searchUserRes?.payload.searchData;
      if (persons !== undefined && persons?.length > 0) {
        var tempArray = [];
        for (let index = 0; index < persons?.length; index++) {
          const element = persons[index];
          // console.log('element: ', element)
          tempArray.push({
            label:
              element.first_name +
              " " +
              element.last_name +
              " " +
              element.username,
            value: element.ID,
            showValue: element.first_name + " " + element.last_name,
          });
        }
        // console.log('searchDataAfterForLoop: ', tempArray)
        setUsers(tempArray);
      } else {
        setUsers([]);
      }
    } else {
      setUsers([]);
    }
  }, [searchUserRes]);

  const userProfileUpdate = () => {
    // LinkedIn validation
    const linkedinPattern = /^https:\/\/linkedin\.com\/in\/[a-zA-Z0-9-_]+\/?$/;
    if (!_.isEmpty(linkdin) && !linkedinPattern.test(linkdin)) {
      setLinkedProfilLinkError(
        "Please enter a valid LinkedIn profile URL (e.g., https://www.linkedin.com/in/username)."
      );
      return;
    }

    // X validation
    const twitterPattern = /^https:\/\/x\.com\/[a-zA-Z0-9_]+\/?$/;
    if (!_.isEmpty(xlink) && !twitterPattern.test(xlink)) {
      setXProfilLinkError(
        "Please enter a valid X profile URL (e.g., https://x.com/username)."
      );
      return;
    }

    if (_.isString(coach) && coach?.length > 0) {
      setIsCoachError(t("Please select correct input for Coach"));
      return;
    }
    if (_.isString(mentor) && mentor?.length > 0) {
      setIsMentorError(t("Please select correct input for Mentor"));
      return;
    }
    if (_.isString(teamLead) && teamLead?.length > 0) {
      setIsTeamLeadError(t("Please select correct input for Team Lead"));
      return;
    }

    if (_.isEmpty(timezone)) {
      setIsTimezoneError(t("Please select timezone from list"));
      return;
    }

    setIsEdit(false);

    setIsLoading(true);
    const defaultLangSet = _.map(
      userDetailRes?.payload?.payload?.coach_info?.skills,
      (course) => {
        return {
          value: course?.id,
          label: course?.name,
        };
      }
    );
    let skillsArr = !_.isEmpty(defaultValue)
      ? defaultValue
      : !_.isEmpty(defaultLangSet)
      ? defaultLangSet
      : [];

    const valuesArray = skillsArr?.map((option) => option.value);

    const defaultAoeSet = _.map(
      userDetailRes?.payload?.payload?.coach_info?.expertise,
      (course) => {
        return {
          value: course?.id,
          label: course?.name,
        };
      }
    );
    let aorArr = !_.isEmpty(defaultExpertiseValue)
      ? defaultExpertiseValue
      : !_.isEmpty(defaultAoeSet)
      ? defaultAoeSet
      : [];

    const valuesAorArray = aorArr?.map((option) => option.value);

    const params = {
      team_lead: teamLead === null ? "" : teamLead,
      mentor: mentor === null ? "" : mentor,
      coach: coach === null ? "" : coach,
      licensedAs: degn === null ? "" : degn,
      timezone: timezone === null ? "" : timezone,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      firstname: firstName,
      office_city: city,
      office_province: province,
      bio: updatedBio,
      experience: selectedExperience
        ? selectedExperience
        : userDetailRes?.payload?.payload?.coach_info?.experience,
      notification_language: selectedNotificationLang
        ? selectedNotificationLang
        : userDetailRes?.payload?.payload?.notification_language,
      industry: selectedIndustry,
      // ? selectedIndustry
      // : userDetailRes?.payload?.payload?.coach_info?.industry
      linkedin: linkdin,
      designation: designation,
      xlink: xlink,
      country: country,
      province: province,
      language_id: selectedLanguage
        ? selectedLanguage
        : userDetailRes?.payload?.payload?.language_id,
      skills: valuesArray,
      expertise: valuesAorArray,
      professional_experience: pfexp
        ? pfexp
        : userDetailRes?.payload?.payload?.coach_info?.professional_experience,
      program_offered: programsOfferedVal
        ? programsOfferedVal
        : userDetailRes?.payload?.payload?.coach_info?.program_offered,
      availability: availabilityFilter
        ? availabilityFilter
        : userDetailRes?.payload?.payload?.coach_info?.availability,
      certifications: ccDocs
        ? ccDocs
        : userDetailRes?.payload?.payload?.coach_info?.certifications,
    };

    dispatch(userUpdate(params));
  };

  const handleChange = (event) => {
    // console.log(event.target.value);
  };

  const getSearchResult = (searchInput, role) => {
    var reqObj = {
      broker_id: localStorage.getItem(SessionKeys.BROKER_ID),
      search: searchInput,
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      user_role: role,
    };

    dispatch(searchUser(reqObj));
  };

  const getOptions = (query) => {
    // console.log(query)
  };

  //User Role Request Status
  useEffect(() => {
    if (usersOfRoleAcceptanceStatus?.status === "success") {
      // console.log('inputs ', coachInput + ', ' + mentorInput + teamLeadInput + ', ')
      if (Array.isArray(usersOfRoleAcceptanceStatus?.payload?.payload)) {
        let roleArr = usersOfRoleAcceptanceStatus?.payload?.payload;
        if (coachInput === "") {
          setSelectedCoachStatus(
            roleArr.filter((i) => i.role_name === "coach")[0]?.status
          );
          setSelectedCoachName(
            roleArr.filter((i) => i.role_name === "coach")[0]?.user_name
          );
          setRequestedCoachId(
            Number(roleArr.filter((i) => i.role_name === "coach")[0]?.role_id)
          );
          setRejectReasonCoach(
            roleArr.filter((i) => i.role_name === "coach")[0]?.reason
          );
        } else {
          setSelectedCoachStatus("Accepted");
          setSelectedCoachName(coachInput);
        }

        if (mentorInput === "") {
          setSelectedMentorStatus(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.status
          );
          setSelectedMentorName(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.user_name
          );
          setRequestedMentorId(
            Number(roleArr.filter((i) => i.role_name === "mentor")[0]?.role_id)
          );
          setRejectReasonMentor(
            roleArr.filter((i) => i.role_name === "mentor")[0]?.reason
          );
        } else {
          setSelectedMentorStatus("Accepted");
          setSelectedMentorName(mentorInput);
        }

        if (teamLeadInput === "") {
          setSelectedTeamLeadStatus(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.status
          );
          setSelectedTeamLeadName(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.user_name
          );
          setRequestedTeamLeadId(
            Number(
              roleArr.filter((i) => i.role_name === "team_lead")[0]?.role_id
            )
          );
          setRejectReasonTeamLead(
            roleArr.filter((i) => i.role_name === "team_lead")[0]?.reason
          );
        } else {
          setSelectedTeamLeadStatus("Accepted");
          setSelectedTeamLeadName(teamLeadInput);
        }
      }
    }
  }, [usersOfRoleAcceptanceStatus]);
  // useEffect(() => {
  //   getRoleReqStatus();
  // }, [])

  const getRoleReqStatus = () => {
    // dispatch(
    //   UserRoleRequestStatus({
    //     module: "userRoleRequestStatus",
    //     postData: { token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) },
    //   })
    // );
  };
  const handleEditorChange = (value, type) => {
    console.log(value, type);
    const rawContentState = convertToRaw(value.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);
    console.log("rawContentState", htmlContent);
    if (type === "pfExp") {
      setProfessionalExperience(value);
      setPfexp(htmlContent);
    } else if (type == "bio") {
      setUpdatedBio(htmlContent);
      setBioInfo(value);
    }
  };

  const handleCoursesEditorChange = (value) => {
    setCoursesOffered(value);
    const rawContentState = convertToRaw(value.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);
    console.log("rawContentState", htmlContent);
    setProgramsOfferedVal(htmlContent);
  };

  const callS3API = (file, type, name, size, dateModified) => {
    setApiCalled(true);
    let fileType = type?.includes("pdf")
      ? "pdf"
      : type?.includes("image")
      ? "image"
      : "pdf";
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("file", file);
    formData.append("type", fileType);
    formData.append("dateModified", dateModified);
    dispatch(getFileUploadOnAWS(formData));
  };

  const downloadPDF = async (pdfUrl, name) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}`); // Specify the name for the downloaded file
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Clean up the DOM
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  const deleteFileFromResourceList = (id) => {
    let updatedResources = ccDocs.filter((item) => item?.id != id);
    setCcDocs(updatedResources);
  };

  const handleResourceFileChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      const selectedFiles = e.target.files;
      const allowedImageTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/webp",
      ];
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        // Get the file details
        const fileName = file.name;
        const fileSize = file.size; // in bytes
        const fileType = file.type;
        const fileLastModified = file.lastModified;

        // Check if the file is an image
        if (!allowedImageTypes.includes(fileType)) {
          setError(t("invalidFileType"));
          setShowLimitPopup(true);
          return;
        } else if (fileSize > 20 * 1048576) {
          setError(t("fileSizeError"));
          setShowLimitPopup(true);
        } else {
          setError("");
          setIsCcDocLoading(true);
          callS3API(file, fileType, fileName, fileSize, fileLastModified);
        }
      }
    }
  };
  var fileRes = useSelector((state) => state.events.fileUploadAWSData);
  useEffect(() => {
    if (!_.isEmpty(fileRes) && apiCalled) {
      if (fileRes?.status === "success") {
        let obj = {
          id: Math.round(Math.random() * 9999),
          name: fileRes?.name,
          type: fileRes?.type,
          url: fileRes?.file_url,
          dateModified: fileRes?.dateModified,
          size: fileRes?.size,
        };

        setCcDocs((resource) => [...resource, obj]);
        setIsCcDocLoading(false);

        setIsLoading(false);
      } else {
        setError(t("uploadFailed"));
        setShowLimitPopup(true);
        setIsLoading(false);
      }
    }
    setApiCalled(false);
  }, [fileRes]);

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <section className="profile-info">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {isLoading ? (
                <ShimmerScreen case={"rect"} height={"30px"} width={"25%"} />
              ) : (
                <h4>{t("personalDetails")}</h4>
              )}
            </div>
          </div>
          <div className="row  mt-4 edit_profile_input">
            <div className="col-xl-4 col-md-6 col-12 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="first_name" className="input__label">
                    {userRole !== "customer" ? t("firstName") : t("name")}
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="input__field"
                    placeholder=" "
                    value={firstName}
                    readOnly={
                      userRole !== "customer" ? true : isEdit ? false : true
                    }
                    onChange={(evt) => {
                      setFirstName(evt.target.value);
                    }}
                  />
                </div>
              )}
            </div>
            {!authBroker.payload?.user.role.includes("provider") && false && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="last_name" className="input__label">
                      {t("middleName")}
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      className="input__field"
                      placeholder=" "
                      value={
                        isOther === "1"
                          ? userDetailResForOther?.payload?.payload?.middlename
                          : userDetailRes?.payload?.payload?.middlename
                      }
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}
            {/* </div> */}
            {/* <div className="row mt-3 edit_profile_input"> */}
            {userRole !== "customer" && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="last_name" className="input__label">
                      {t("lastName")}
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      className="input__field"
                      placeholder=" "
                      value={
                        isOther === "1"
                          ? userDetailResForOther?.payload?.payload?.lastname
                          : userDetailRes?.payload?.payload?.lastname
                      }
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}

            <div className="col-xl-4 col-md-6 col-12 required">
              {isLoading ? (
                <div className="input-text position-relative disable_field">
                  <ShimmerScreen case={"rect"} width={"60%"} height={"12px"} />
                  <span className="input__field" style={{ marginTop: "5px" }}>
                    <ShimmerScreen
                      case={"rect"}
                      width={"100%"}
                      height={"25px"}
                    />
                  </span>
                </div>
              ) : (
                <div className="input-text position-relative disable_field">
                  <label htmlFor="email" className="input__label">
                    {t("emailAddress")}
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="input__field"
                    placeholder=" "
                    value={
                      isOther === "1"
                        ? userDetailResForOther?.payload?.payload?.email
                        : userDetailRes?.payload?.payload?.email
                    }
                    readOnly
                  />
                </div>
              )}
            </div>

            {userRole === "provider" && false && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-lear position-relative disable_field">
                    <label htmlFor="category" className="input__label">
                      {t("Designation")}
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="degn"
                      className="input__field"
                      placeholder="enter designation"
                      value={designation}
                      onChange={(e) => setDesignation(e.target.value)}
                      disabled={!isEdit}
                    />
                  </div>
                )}
              </div>
            )}
            {/* </div> */}
            {isHost || userRole === "provider" ? (
              ""
            ) : userRole !== "customer" &&
              // <div className="row mt-3 edit_profile_input">
              !isGuest ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="date_join" className="input__label">
                      {t("Hire Date")} (MM/DD/YYYY)
                    </label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="text"
                        id="date_join"
                        name="date_join"
                        className="input__field"
                        placeholder=" "
                        value={
                          isOther === "1"
                            ? userDetailResForOther?.payload?.payload?.doj
                            : userDetailRes?.payload?.payload?.doj
                        }
                        readOnly
                      />
                      <img
                        src="/images/finwell-img/edit_profile_calPG011.png"
                        width="28"
                        height="28"
                        alt="calendar"
                      />
                    </div>
                  </div>
                )}
              </div>
            ) : userRole !== "customer" &&
              userRole !== "provider" &&
              authBroker.payload?.user?.config?.learning_points !== "false"  && false ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("manager")}
                    </label>
                    <input
                      type="text"
                      id="manager"
                      name="manager"
                      className="input__field"
                      placeholder=" "
                      value={
                        isOther === "1"
                          ? userDetailResForOther?.payload?.payload?.manager
                          : userDetailRes?.payload?.payload?.manager
                      }
                      readOnly
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        {t("Linkedin Profile Link")}
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field"
                        placeholder=" "
                        onChange={(e) => setlinkdin(e.target.value)}
                        value={linkdin}
                        readOnly={isEdit ? false : true}
                      />
                    </div>
                    <p className="error-msg">{linkedProfilLinkError}</p>
                  </>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        {t("X Profile Link")}
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field"
                        placeholder=" "
                        onChange={(e) => setXlink(e.target.value)}
                        value={xlink}
                        readOnly={isEdit ? false : true}
                      />
                    </div>
                    <p className="error-msg">{xProfilLinkError}</p>
                  </>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false  ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Industry")}
                    </label>
                    <select
                      className="form-select input_searchfield"
                      id="category"
                      aria-label="Default select example"
                      disabled={isEdit ? false : true}
                      value={selectedIndustry}
                      onChange={(ev) => {
                        setSelectedIndustry(ev.target.value);
                      }}
                    >
                      <option
                        value=""
                        selected={
                          selectedIndustry === "" ||
                          selectedIndustry === null ||
                          selectedIndustry === undefined
                        }
                      >
                        Select...
                      </option>
                      {industry.map((cat, index) => {
                        return (
                          <option
                            value={cat?.id}
                            selected={
                              selectedIndustry === cat?.id ? true : false
                            }
                            key={index}
                          >
                            {cat?.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false  ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Experience")}
                    </label>
                    {/* <select
                      className="form-select input_searchfield"
                      onChange={(ev) => {
                        setSelectedExperience(ev.target.value);
                      }}
                      value={selectedExperience}
                      disabled={isEdit ? false : true}
                    >
                      {experience.map((ex, index) => {
                        return (
                          <option
                            value={ex?.id}
                            selected={
                              selectedExperience === ex?.id ? true : false
                            }
                            key={index}
                          >
                            {ex?.value}
                          </option>
                        );
                      })}
                    </select> */}

                    <Select
                      isMulti={false}
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      options={experience}
                      value={experience.find(
                        (option) => option.value === selectedExperience
                      )}
                      onChange={(selectedOption) =>
                        setSelectedExperience(selectedOption?.value)
                      }
                      isDisabled={!isEdit}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false  ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Country")}
                    </label>
                    <select
                      className="form-select input_searchfield"
                      onChange={(ev) => {
                        setCountry(ev.target.value);
                      }}
                      value={country}
                      disabled={isEdit ? false : true}
                    >
                      <option
                        value=""
                        selected={
                          country === "" ||
                          country === null ||
                          country === undefined
                        }
                      >
                        Select...
                      </option>
                      {countryDatas.map((ex, index) => {
                        return (
                          <option
                            value={ex?.id}
                            selected={country === ex?.id ? true : false}
                            key={index}
                          >
                            {ex?.name}
                          </option>
                        );
                      })}
                      {/* Add options here */}
                    </select>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {!isHost &&false &&  (
              <div className="col-md-4">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-lear position-relative">
                      <label
                        htmlFor="category"
                        className="input__label"
                      >
                        {t("province")}
                      </label>
                      <select
                        className="form-select input_searchfield"
                        id="category"
                        aria-label="Default select example"
                        disabled={isEdit ? false : true}
                        value={province}
                        onChange={(ev) => {
                          setProvince(ev.target.value);
                        }}
                      >
                        {/* <option selected="" value="">Select Timezone</option> */}
                        <option
                          value=""
                          selected={
                            province === "" ||
                            province === null ||
                            province === undefined
                          }
                        >
                          Select...
                        </option>
                        {provinceList?.map((cat, index) => {
                          return (
                            <option
                              value={cat.id}
                              selected={province === cat.name ? true : false}
                              key={index}
                            >
                              {cat.name}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </>
                )}
              </div>
            )}

            {!isHost && false && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="city" className="input__label">
                      {t("city")}
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      className="input__field"
                      placeholder=" "
                      value={city}
                      readOnly={isEdit ? false : true}
                      onChange={(evt) => {
                        setCity(evt.target.value);
                      }}
                    />

                    {/* <select
                      className="form-select input_searchfield"
                      id="category"
                      aria-label="Default select example"
                      disabled={isEdit ? false : true}
                      onChange={(ev) => {
                        setCity(ev.target.value);
                      }}
                    >
                      {citiesData?.map((cat, index) => {
                        return (
                          <option
                            value={cat.id}
                            selected={
                              userDetailRes?.payload?.payload?.office_city ===
                              cat.id
                                ? true
                                : false
                            }
                            key={index}
                          >
                            {cat.city}{" "}
                          </option>
                        );
                      })}
                    </select> */}
                    {/* <Select
                        isMulti={false}
                        name="colors"
                        className="basic-multi-select w-100 multi-label-select"
                        classNamePrefix="xsel"
                        options={citiesData}
                        value={citiesData?.find(
                          (option) =>
                          option.label === userDetailRes?.payload?.payload?.office_city
                        )}
                        placeholder="Select city"
                        onChange={(selectedOption) =>
                          setCity(selectedOption?.label)
                        }
                        isDisabled={!isEdit}
                      /> */}
                  </div>
                )}
              </div>
            )}

            {!isHost &&
              userRole !== "customer" &&
              userRole !== "provider" &&
              false && (
                <div className="col-xl-4 col-md-6 col-12 required">
                  {isLoading ? (
                    <div className="input-text position-relative disable_field">
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <div className="input-lear position-relative disable_field">
                      <label
                        htmlFor="category"
                        className="input__label"
                      >
                        {t("title")}
                      </label>
                      <input
                        type="text"
                        id="email"
                        name="email"
                        className="input__field"
                        placeholder=" "
                        value={recoData}
                        readOnly
                      />
                    </div>
                  )}
                </div>
              )}

            {/* <div className="row mt-3 edit_profile_input"> */}
            {userRole !== "customer" && false  ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("language")}
                    </label>
                    {/* <select
                      className="form-select input_searchfield"
                      onChange={(ev) => {
                        setSelectedLanguage(ev.target.value);
                      }}
                      value={selectedLanguage}
                      disabled={isEdit ? false : true}
                    >
                      {languagesList?.map((ex, index) => {
                        return (
                          <option
                            value={ex?.id}
                            selected={
                              selectedLanguage === ex?.id ? true : false
                            }
                            key={index}
                          >
                            {ex?.name}
                          </option>
                        );
                      })}
                    </select> */}
                    <Select
                      isMulti
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      options={languagesList}
                      value={defaultLangValue}
                      onChange={(e) => {
                        if (!_.isEmpty(e)) {
                          let data = [];
                          console.log("check---", e);
                          for (let language of languageSet) {
                            for (let sO of e) {
                              if (
                                _.toNumber(sO.value) === _.toNumber(language.id)
                              ) {
                                data.push(language);
                              }
                            }
                          }
                          console.log("set data", data);
                          setSelectedLanguage(data);
                        } else {
                          setSelectedLanguage([]);
                        }
                      }}
                      isDisabled={!isEdit}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole !== "customer" && false  ? (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Notification Language")}
                    </label>
                    <Select
                      isMulti={false}
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      options={languagesList}
                      value={languagesList.find(
                        (option) => option.value === selectedNotificationLang
                      )}
                      onChange={(selectedOption) =>
                        setSelectedNotificationLang(selectedOption?.value)
                      }
                      isDisabled={!isEdit}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {!isHost && userRole !== "customer" && false && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="province" className="input__label">
                      {t("province")}
                    </label>
                    <input
                      type="text"
                      id="province"
                      name="province"
                      className="input__field"
                      placeholder=" "
                      value={
                        isOther === "1"
                          ? userDetailResForOther?.payload?.payload
                              ?.office_province
                          : userDetailRes?.payload?.payload?.office_province
                      }
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}

            {/* <div className="row mt-3 edit_profile_input"> */}
            {userRole !== "customer" && !isHost && userRole !== "provider" && (
              <div className="col-xl-4 col-md-6 col-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="province" className="input__label">
                      {!_.isEmpty(
                        localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME)
                      ) &&
                      localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME) !==
                        "undefined"
                        ? localStorage.getItem(SessionKeys.SHOW_OFFICE_NAME)
                        : t("Office Location Name")}
                    </label>
                    <input
                      type="text"
                      id="province"
                      name="province"
                      className="input__field"
                      placeholder=" "
                      value={
                        isOther === "1"
                          ? userDetailResForOther?.payload?.payload?.office_name
                          : userDetailRes?.payload?.payload?.office_name
                      }
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}
            {
              <div className="col-md-4">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="input-lear position-relative">
                      <label htmlFor="category" className="input__label">
                        {t("timeZone")}
                      </label>

                      <Select
                        isMulti={false}
                        name="colors"
                        className="basic-multi-select w-100 multi-label-select"
                        classNamePrefix="xsel"
                        options={timezoneList}
                        value={timezoneList.find(
                          (option) =>
                            _.toNumber(option.value) === _.toNumber(timezone)  
                        ) || null }
                        onChange={(selectedOption) =>
                          setTimezone(selectedOption?.value)
                        }
                        isDisabled={true}
                        readOnly
                        placeholder=""
                      />
                    </div>
                    <p className="error-msg">{isTimeZoneError}</p>
                  </>
                )} 
              </div>
            }
            {/* </div> */}

            {!isGuest &&
              !isHost &&
              userRole !== "customer" &&
              authBroker.payload?.user?.config?.reco_license !== "false" && (
                //   <div className="row mt-3 edit_profile_input">
                <>
                  {false && (
                    <>
                      {" "}
                      <div className="col-xl-4 col-md-6 col-12 required">
                        {isLoading ? (
                          <div className="input-text position-relative disable_field">
                            <ShimmerScreen
                              case={"rect"}
                              width={"60%"}
                              height={"12px"}
                            />
                            <span
                              className="input__field"
                              style={{ marginTop: "5px" }}
                            >
                              <ShimmerScreen
                                case={"rect"}
                                width={"100%"}
                                height={"25px"}
                              />
                            </span>
                          </div>
                        ) : (
                          <div className="input-text position-relative disable_field">
                            <label
                              htmlFor="licence_date"
                              className="input__label"
                            >
                              {t("rECOLicenceIssueDate")} (MM/DD/YYYY)
                            </label>
                            <div className="d-flex align-items-center gap-2">
                              <input
                                type="text"
                                id="licence_date"
                                name="licence_date"
                                className="input__field"
                                placeholder=" "
                                value={
                                  isOther === "1"
                                    ? userDetailResForOther?.payload?.payload
                                        ?.license_date
                                    : userDetailRes?.payload?.payload
                                        ?.license_date
                                }
                                readOnly
                              />
                              <img
                                src="/images/finwell-img/edit_profile_calPG011.png"
                                width="28"
                                height="28"
                                alt="calendar"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-xl-4 col-md-6 col-12 required">
                        {isLoading ? (
                          <div className="input-text position-relative disable_field">
                            <ShimmerScreen
                              case={"rect"}
                              width={"60%"}
                              height={"12px"}
                            />
                            <span
                              className="input__field"
                              style={{ marginTop: "5px" }}
                            >
                              <ShimmerScreen
                                case={"rect"}
                                width={"100%"}
                                height={"25px"}
                              />
                            </span>
                          </div>
                        ) : (
                          <div className="input-text position-relative disable_field">
                            <label
                              htmlFor="license_num"
                              className="input__label"
                            >
                              {t("rECOLicenseNumber")}
                            </label>
                            <input
                              type="text"
                              id="license_num"
                              name="license_num"
                              className="input__field"
                              placeholder=" "
                              value={
                                isOther === "1"
                                  ? userDetailResForOther?.payload?.payload
                                      ?.license_number
                                  : userDetailRes?.payload?.payload
                                      ?.license_number
                              }
                              readOnly
                            />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </>
                //   </div>
              )}
            {!isGuest &&
              userRole !== "customer" &&
              false &&
              !isHost &&
              // <div className="row mt-3 edit_profile_input">
              authBroker.payload?.user?.config?.reco_license !== "false" && (
                <div className="col-xl-4 col-md-6 col-12 required">
                  {isLoading ? (
                    <div className="input-text position-relative disable_field">
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        {t("brokerOfRecord")}
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field"
                        placeholder=" "
                        value={
                          isOther === "1"
                            ? userDetailResForOther?.payload?.payload
                                ?.broker_of_records
                            : userDetailRes?.payload?.payload?.broker_of_records
                        }
                        readOnly
                      />
                    </div>
                  )}
                </div>
              )}

            {!isHost &&
              userRole !== "customer" &&
              userRole !== "provider" &&
              authBroker.payload?.user?.config?.learning_points !== "false" && false &&(
                <div className="col-xl-4 col-md-6 col-12 required">
                  {isLoading ? (
                    <div className="input-text position-relative disable_field">
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <div className="input-text position-relative disable_field">
                      <label htmlFor="manager" className="input__label">
                        {t("manager")}
                      </label>
                      <input
                        type="text"
                        id="manager"
                        name="manager"
                        className="input__field"
                        placeholder=" "
                        value={
                          isOther === "1"
                            ? userDetailResForOther?.payload?.payload?.manager
                            : userDetailRes?.payload?.payload?.manager
                        }
                        readOnly
                      />
                    </div>
                  )}
                </div>
              )}

            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("skills")}
                    </label>
                    <Select
                      isMulti
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      placeholder="Select skills"
                      options={skillsList}
                      value={defaultValue}
                      isDisabled={!isEdit}
                      isLoading={isLoading}
                      //menuIsOpen={true}
                      onChange={(e) => {
                        console.log(e);
                        if (!_.isEmpty(e)) {
                          let data = [];
                          console.log("check---", e);
                          for (let skill of skillsSet) {
                            for (let sO of e) {
                              if (
                                _.toNumber(sO.value) === _.toNumber(skill.id)
                              ) {
                                data.push(skill);
                              }
                            }
                          }
                          console.log("set data", data);
                          setSelectedSkills(data);
                        } else {
                          setSelectedSkills([]);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Areas of Expertise")}
                    </label>
                    <Select
                      isMulti
                      name="colors"
                      className="basic-multi-select w-100 multi-label-select"
                      classNamePrefix="xsel"
                      placeholder="Select areas of expertise"
                      options={aoeList}
                      value={defaultExpertiseValue}
                      isDisabled={!isEdit}
                      isLoading={isLoading}
                      //menuIsOpen={true}
                      onChange={(e) => {
                        console.log(e);
                        if (!_.isEmpty(e)) {
                          let data = [];
                          console.log("check---", e);
                          for (let skill of aoeSet) {
                            for (let sO of e) {
                              if (
                                _.toNumber(sO.value) === _.toNumber(skill.id)
                              ) {
                                data.push(skill);
                              }
                            }
                          }
                          console.log("set data", data);
                          setSelectedAoe(data);
                        } else {
                          setSelectedAoe([]);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("professionalSummary")}
                    </label>
                    {isEdit ? (
                      <Editor
                        editorState={bioInfo}
                        onEditorStateChange={(e) =>
                          handleEditorChange(e, "bio")
                        }
                        readOnly={!isEdit}
                        toolbar={{
                          options: [
                            "inline",
                            "blockType",
                            "fontSize",
                            "list",
                            "textAlign",
                            "link",
                            "image",
                            "history",
                          ],
                          inline: {
                            options: [
                              "bold",
                              "italic",
                              "underline",
                              "strikethrough",
                            ],
                          },
                          blockType: {
                            options: ["Normal", "H1", "H2", "H3", "Blockquote"],
                          },
                          list: { options: ["unordered", "ordered"] },
                          textAlign: {
                            options: ["left", "center", "right", "justify"],
                          },
                        }}
                        placeholder="Enter the description here"
                      />
                    ) : (
                      <div
                        className="border border-2 p-4 rounded"
                        dangerouslySetInnerHTML={{
                          __html: updatedBio,
                        }}
                      />
                    )}
                    {/* <textarea
                      type="text"
                      id="manager"
                      name="manager"
                      rows={1}
                      className="input__field"
                      placeholder=" "
                      value={updatedBio}
                      onChange={(e) => setUpdatedBio(e.target.value)}
                      readOnly={isEdit ? false : true}
                    /> */}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("professionalExperienceHighlights")}
                    </label>
                    {isEdit ? (
                      <Editor
                        editorState={professionalExperience}
                        onEditorStateChange={(e) =>
                          handleEditorChange(e, "pfExp")
                        }
                        readOnly={!isEdit}
                        toolbar={{
                          options: [
                            "inline",
                            "blockType",
                            "fontSize",
                            "list",
                            "textAlign",
                            "link",
                            "image",
                            "history",
                          ],
                          inline: {
                            options: [
                              "bold",
                              "italic",
                              "underline",
                              "strikethrough",
                            ],
                          },
                          blockType: {
                            options: ["Normal", "H1", "H2", "H3", "Blockquote"],
                          },
                          list: { options: ["unordered", "ordered"] },
                          textAlign: {
                            options: ["left", "center", "right", "justify"],
                          },
                        }}
                        placeholder="Enter the description here"
                      />
                    ) : (
                      <div
                        className="border border-2 p-4 rounded"
                        dangerouslySetInnerHTML={{
                          __html: profExpPlain,
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("Courses/ProgramsOffered")}
                    </label>
                    {isEdit ? (
                      <Editor
                        editorState={coursesOffered}
                        onEditorStateChange={handleCoursesEditorChange}
                        readOnly={!isEdit}
                        toolbar={{
                          options: [
                            "inline",
                            "blockType",
                            "fontSize",
                            "list",
                            "textAlign",
                            "link",
                            "image",
                            "history",
                          ],
                          inline: {
                            options: [
                              "bold",
                              "italic",
                              "underline",
                              "strikethrough",
                            ],
                          },
                          blockType: {
                            options: ["Normal", "H1", "H2", "H3", "Blockquote"],
                          },
                          list: { options: ["unordered", "ordered"] },
                          textAlign: {
                            options: ["left", "center", "right", "justify"],
                          },
                        }}
                        placeholder="Enter the description here"
                      />
                    ) : (
                      <div
                        className="border border-2 p-4 rounded"
                        dangerouslySetInnerHTML={{
                          __html: coursesOfferedPlain,
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="input-text position-relative disable_field">
                    <label htmlFor="manager" className="input__label">
                      {t("availability")}
                    </label>
                    <div className="select-status">
                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={availabilityFilter.includes("live-sessions")}
                          onChange={() => {
                            let filterClone = _.cloneDeep(availabilityFilter);
                            if (availabilityFilter.includes("live-sessions")) {
                              filterClone = filterClone.filter(
                                (opt) => opt !== "live-sessions"
                              );
                            } else {
                              filterClone.push("live-sessions");
                            }
                            setAvailabilityFilter(filterClone);
                          }}
                          disabled={!isEdit}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          {t("liveSessionsInPersonOrVirtual")}
                        </label>
                      </div>

                      <div className="form-check cursor-pointer">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          checked={availabilityFilter.includes("one-to-one")}
                          onChange={() => {
                            let filterClone = _.cloneDeep(availabilityFilter);
                            if (availabilityFilter.includes("one-to-one")) {
                              filterClone = filterClone.filter(
                                (opt) => opt !== "one-to-one"
                              );
                            } else {
                              filterClone.push("one-to-one");
                            }
                            setAvailabilityFilter(filterClone);
                          }}
                          disabled={!isEdit}
                        />
                        <label
                          className="form-check-label cursor-pointer"
                          for="termofusein"
                        >
                          {t("OneonOneCoaching")}
                        </label>
                      </div>

                      {false && (
                        <div className="form-check cursor-pointer">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            checked={availabilityFilter.includes("webinar")}
                            onChange={() => {
                              let filterClone = _.cloneDeep(availabilityFilter);
                              if (availabilityFilter.includes("webinar")) {
                                filterClone = filterClone.filter(
                                  (opt) => opt !== "webinar"
                                );
                              } else {
                                filterClone.push("webinar");
                              }
                              setAvailabilityFilter(filterClone);
                            }}
                            disabled={!isEdit}
                          />
                          <label
                            className="form-check-label cursor-pointer"
                            for="termofusein"
                          >
                            {t("groupWebinars")}
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {userRole === "provider" ? (
              <div className="col-md-12 required">
                {isLoading ? (
                  <div className="input-text position-relative disable_field">
                    <ShimmerScreen
                      case={"rect"}
                      width={"60%"}
                      height={"12px"}
                    />
                    <span
                      className="input__field"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"100%"}
                        height={"25px"}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="group-worshopdetail-frm">
                    <label htmlFor="workshopResource" className="form-label">
                      {t("certifications&Credentials")}{" "}
                    </label>
                    <div className="d-flex  gap-5">
                      <div
                        className={`file-uploader ${
                          !isEdit ? "cursor-not-allowed" : "cursor-pointer"
                        }`}
                        onClick={() =>
                          isEdit && document.getElementById("file2").click()
                        }
                      >
                        <div className="iocn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="18"
                            viewBox="0 0 24 18"
                            fill="none"
                          >
                            <path
                              d="M11.3691 6.05273C11.7031 5.71875 12.2598 5.71875 12.5938 6.05273L15.5625 9.02148C15.9336 9.39257 15.9336 9.94921 15.5625 10.2832C15.2285 10.6543 14.6719 10.6543 14.3379 10.2832L12.8906 8.83593V13.8086C12.8906 14.3281 12.4824 14.6992 12 14.6992C11.4805 14.6992 11.1094 14.3281 11.1094 13.8086V8.83593L9.625 10.2832C9.29102 10.6543 8.73438 10.6543 8.40039 10.2832C8.0293 9.94921 8.0293 9.39257 8.40039 9.02148L11.3691 6.05273ZM5.46875 17.3711C2.5 17.3711 0.125 14.9961 0.125 12.0274C0.125 9.72656 1.60938 7.72265 3.6875 7.01757V6.98047C3.6875 3.5664 6.4707 0.746094 9.92188 0.746094C11.7773 0.746094 13.4844 1.59961 14.6348 2.93554C15.1914 2.67578 15.7852 2.52734 16.4531 2.52734C18.9023 2.52734 20.9062 4.53125 20.9062 6.98047C20.9062 7.24023 20.8691 7.46289 20.832 7.72265C22.6133 8.50195 23.875 10.2832 23.875 12.3242C23.875 15.0332 21.7598 17.2227 19.125 17.3711H5.46875ZM9.92188 2.52734C7.43555 2.52734 5.46875 4.53125 5.46875 6.98047V8.27929L4.24414 8.6875C2.87109 9.16992 1.90625 10.5059 1.90625 12.0274C1.90625 13.9941 3.46484 15.5898 5.46875 15.5898H18.9023H19.0137C20.7207 15.5156 22.0938 14.0684 22.0938 12.3242C22.0938 10.9883 21.2773 9.83789 20.127 9.35547L18.8652 8.79882L19.0879 7.42578C19.0879 7.27734 19.125 7.1289 19.125 6.98047C19.125 5.5332 17.9004 4.30859 16.4531 4.30859C16.0449 4.30859 15.6738 4.41992 15.3398 4.56836L14.1523 5.08789L13.2617 4.08593C12.4453 3.1582 11.2578 2.52734 9.88477 2.52734H9.92188Z"
                              fill="#2D2D2D"
                            />
                          </svg>
                        </div>
                        <div className="textf">FILE FORMAT(S)</div>
                        <div className="filemsg">
                          {t("dropUpTo20MBFilesHereToUploadOr")}
                        </div>
                        <label
                          for="file-upload1"
                          className={`upload-link chossefiles`}
                        >
                          {t("chooseFiles")}
                        </label>
                        <input
                          type="file"
                          id="file2"
                          className="upload-input"
                          accept="image/*"
                          onChange={handleResourceFileChange}
                          disabled={!isEdit}
                        />

                        <div className="w-100">
                          {ccDocs?.map((item) => {
                            return (
                              <ul className="listinguploadee  mt-4">
                                <li>
                                  <span className="lef-infopx1">
                                    <span className="iconxload">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="23"
                                        viewBox="0 0 18 23"
                                        fill="none"
                                      >
                                        <path
                                          d="M16.4336 4.09765L13.2109 0.875004C12.6953 0.359374 12.0078 0.0585938 11.2773 0.0585938H3.5C1.95312 0.0585938 0.75 1.30468 0.75 2.80859V19.3086C0.75 20.8555 1.95312 22.0586 3.5 22.0586H14.5C16.0039 22.0586 17.25 20.8555 17.25 19.3086V6.03125C17.25 5.30078 16.9492 4.61328 16.4336 4.09765ZM15.1875 19.3086C15.1875 19.6953 14.8438 19.9961 14.5 19.9961H3.5C3.11328 19.9961 2.8125 19.6953 2.8125 19.3086V2.85156C2.8125 2.46484 3.11328 2.16406 3.5 2.16406H10.375V5.55859C10.375 6.33203 10.9766 6.93359 11.75 6.93359H15.1445V19.3086H15.1875ZM9.98828 12.6055C9.77344 12.6055 9.60156 12.7344 9.47266 12.9063L7.79688 15.4414L7.28125 14.7109C7.15234 14.5391 6.98047 14.4102 6.76562 14.4102C6.59375 14.4102 6.37891 14.5391 6.29297 14.7109L4.27344 17.7188C4.14453 17.8906 4.14453 18.1484 4.23047 18.3203C4.35938 18.5352 4.53125 18.6211 4.74609 18.6211H13.168C13.3828 18.6211 13.5977 18.5352 13.6836 18.3203C13.7695 18.1484 13.7695 17.8906 13.6406 17.7188L10.4609 12.9063C10.375 12.7344 10.2031 12.6055 9.98828 12.6055ZM6.25 12.4336C6.98047 12.4336 7.625 11.832 7.625 11.0586C7.625 10.3281 6.98047 9.68359 6.25 9.68359C5.47656 9.68359 4.875 10.3281 4.875 11.0586C4.875 11.832 5.47656 12.4336 6.25 12.4336Z"
                                          fill="#2D2D2D"
                                        />
                                      </svg>
                                    </span>
                                    <span className="filename">
                                      {item?.name}
                                    </span>
                                  </span>
                                  <span className="rightds">
                                    <span className="filtduploaddate">
                                      {item?.dateModified &&
                                        dateTimeStamp(item?.dateModified) +
                                          " | "}
                                      {item?.size > 0 &&
                                        (item?.size / (1024 * 1024)).toFixed(
                                          2
                                        ) + "MB"}
                                    </span>
                                    <span className="downloandicon d-flex gap-2">
                                      <svg
                                        className="cursor-pointer iconde"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="23"
                                        viewBox="0 0 20 23"
                                        fill="none"
                                        onClick={() => {
                                          downloadPDF(item?.url, item?.name);
                                        }}
                                      >
                                        <path
                                          d="M15.5 22.0586H4.5C2.17969 22.0586 0.375 20.2539 0.375 17.9336V14.8398C0.375 14.2813 0.804688 13.8086 1.40625 13.8086C1.96484 13.8086 2.4375 14.2813 2.4375 14.8398V17.9336C2.4375 19.0938 3.33984 19.9961 4.5 19.9961H15.5C16.6172 19.9961 17.5625 19.0938 17.5625 17.9336V14.8398C17.5625 14.2813 17.9922 13.8086 18.5938 13.8086C19.1523 13.8086 19.625 14.2813 19.625 14.8398V17.9336C19.625 20.2109 17.7773 22.0586 15.5 22.0586ZM10.6875 14.9258L16.5312 9.42579C16.9609 9.03906 16.9609 8.39453 16.5742 7.96484C16.1875 7.53515 15.543 7.53515 15.1133 7.92187L11.0312 11.7891V1.08984C11.0312 0.531254 10.5586 0.0585938 10 0.0585938C9.39844 0.0585938 8.96875 0.531254 8.96875 1.08984V11.7891L4.84375 7.92187C4.41406 7.53515 3.76953 7.53515 3.38281 7.96484C3.21094 8.17968 3.125 8.4375 3.125 8.65234C3.125 8.95312 3.21094 9.21093 3.42578 9.42579L9.26953 14.9258C9.65625 15.3125 10.3008 15.3125 10.6875 14.9258Z"
                                          fill="#2D2D2D"
                                        />
                                      </svg>
                                      <svg
                                        className={"cursor-pointer iconde"}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="23"
                                        viewBox="0 0 20 23"
                                        fill="none"
                                        onClick={() =>
                                          deleteFileFromResourceList(item?.id)
                                        }
                                      >
                                        <path
                                          d="M7.28571 17.2461C7.28571 17.6328 6.94643 17.9336 6.60714 17.9336C6.22545 17.9336 5.92857 17.6328 5.92857 17.2461V8.30859C5.92857 7.96484 6.22545 7.62109 6.60714 7.62109C6.94643 7.62109 7.28571 7.96484 7.28571 8.30859V17.2461ZM10.6786 17.2461C10.6786 17.6328 10.3393 17.9336 10 17.9336C9.6183 17.9336 9.32143 17.6328 9.32143 17.2461V8.30859C9.32143 7.96484 9.6183 7.62109 10 7.62109C10.3393 7.62109 10.6786 7.96484 10.6786 8.30859V17.2461ZM14.0714 17.2461C14.0714 17.6328 13.7321 17.9336 13.3929 17.9336C13.0112 17.9336 12.7143 17.6328 12.7143 17.2461V8.30859C12.7143 7.96484 13.0112 7.62109 13.3929 7.62109C13.7321 7.62109 14.0714 7.96484 14.0714 8.30859V17.2461ZM13.9442 1.13281L15.5134 3.49609H18.4822C19.0334 3.49609 19.5 3.96875 19.5 4.52734C19.5 5.1289 19.0334 5.55859 18.4822 5.55859H18.1429V18.6211C18.1429 20.5547 16.616 22.0586 14.75 22.0586H5.25C3.34152 22.0586 1.85714 20.5547 1.85714 18.6211V5.55859H1.51786C0.924108 5.55859 0.5 5.1289 0.5 4.52734C0.5 3.96875 0.924108 3.49609 1.51786 3.49609H4.44419L6.0134 1.13281C6.4375 0.488284 7.20089 0.0585938 8.0067 0.0585938H11.9509C12.7567 0.0585938 13.5201 0.488284 13.9442 1.13281ZM6.90402 3.49609H13.0536L12.2477 2.29297C12.2054 2.20703 12.0782 2.12109 11.9509 2.12109H8.0067C7.87946 2.12109 7.75224 2.20703 7.70982 2.29297L6.90402 3.49609ZM3.89286 18.6211C3.89286 19.3945 4.4866 19.9961 5.25 19.9961H14.75C15.471 19.9961 16.1071 19.3945 16.1071 18.6211V5.55859H3.89286V18.6211Z"
                                          fill="#2D2D2D"
                                        />
                                      </svg>
                                    </span>
                                  </span>
                                </li>
                              </ul>
                            );
                          })}
                          {isCcDocLoading && (
                            <ul className="listinguploadee mt-4 ">
                              <ShimmerScreen
                                case="rect"
                                height="0.5rem"
                                width="100%"
                              />
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          {/* </div> */}

          {!_.isEmpty(authBroker) && false || true ? (
            ""
          ) : (userRole === "realtor" || userRole === "manager") &&
            userRole !== "customer" ? (
            <>
              <div className="row mt-3 mb-2 edit_profile_input userdetslsd">
                <div className="col-md-12">
                  <div className="frmsep"></div>

                  {isLoading ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"30px"}
                      width={"35%"}
                    />
                  ) : (
                    <label className="role_head">
                      {t("additionalOrganizationSupport")}
                    </label>
                  )}
                </div>
              </div>

              <div className="row mt-3 edit_profile_input userdetslsd">
                {false && <div className="col-md-4">
                  {isLoading ? (
                    <div
                      className="input-text position-relative"
                      style={{ marginTop: "5px" }}
                    >
                      <ShimmerScreen
                        case={"rect"}
                        width={"60%"}
                        height={"12px"}
                      />
                      <span
                        className="input__field"
                        style={{ marginTop: "5px" }}
                      >
                        <ShimmerScreen
                          case={"rect"}
                          width={"100%"}
                          height={"25px"}
                        />
                      </span>
                    </div>
                  ) : (
                    <>
                      <div
                        className={`input-text position-relative ${
                          isEdit ? "input__field_auto_cmplt" : ""
                        }`}
                      >
                        <label for="coach" className="input__label">
                          Coach
                        </label>
                        <Autocomplete
                          disabled={isEdit ? false : true}
                          disablePortal
                          size="small"
                          id="combo-box-demo"
                          autoComplete
                          includeInputInList
                          className={`${
                            coachInput ? "has-value" : "has-no-value"
                          }`}
                          options={
                            coachInput !== undefined && coachInput?.length >= 2
                              ? users
                              : [
                                  {
                                    label: t("typeAtLeast3Char"),
                                    value: "",
                                    showValue: t("typeAtLeast3Char"),
                                  },
                                ]
                          }
                          sx={{ width: "100%" }}
                          onChange={(event, value) => {
                            // if (
                            //     value.value === teamLead ||
                            //     value.value === mentor ||
                            //     value.value === requestedTeamLeadId ||
                            //     value.value === requestedMentorId
                            // ) {
                            //     setIsCoachError(
                            //         "Please select different user for mentor and coach."
                            //     );
                            //     setCoach("");
                            //     setCoachInput("");
                            // } else {
                            if (_.isEmpty(value)) {
                            } else {
                              setIsCoachError("");
                              setCoach(value.value);
                              setCoachInput(value.showValue);
                            }
                            // }
                          }}
                          onInputChange={(e) => {
                            setCurrentRole(1);
                            if (e !== null) {
                              setCoachInput(e.target.value);
                              // dispatch(selectedCoach(e.target.value))
                              setCoach(e.target.value);
                              if (e.target.value?.length > 2) {
                                getSearchResult(e.target.value.trim(), "coach");
                              } else {
                                setUsers([]);
                              }
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label={t("")} />
                          )}
                          value={coachInput}
                        />
                      </div>

                      <div className="statusshowsec">
                        {!_.isEmpty(selectedCoachStatus) ? (
                          selectedCoachStatus?.toLowerCase() === "reject" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_34_20919)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#F57C7C"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFCACA"
                                  />
                                  <path
                                    d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_34_20919">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedCoachName}</b>{" "}
                                  {t("hasRejectedYourRequest")}.{" "}
                                  {rejectReasonCoach && (
                                    <>
                                      <b> {t("reason")}: </b>{" "}
                                      {rejectReasonCoach}
                                    </>
                                  )}
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedCoachName}</b>{" "}
                                  {t("hasRejectedTheRequest")}{" "}
                                  {rejectReasonCoach && (
                                    <>
                                      <b> {t("reason")}: </b>{" "}
                                      {rejectReasonCoach}
                                    </>
                                  )}
                                </span>
                              )}
                            </p>
                          ) : selectedCoachStatus?.toLowerCase() ===
                            "pending" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105419)">
                                  <path
                                    d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                    fill="#FAA16F"
                                  />
                                  <path
                                    d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                    fill="#FFDDCA"
                                  />
                                  <path
                                    d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105419">
                                    <rect
                                      width="13.988"
                                      height="14"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              {isOther === "0" ? (
                                <span>
                                  {t("yourRequestIsPendingWith")}{" "}
                                  <b>{selectedCoachName}</b>.
                                </span>
                              ) : (
                                <span>
                                  {t("requestIsPendingWith")}{" "}
                                  <b>{selectedCoachName}</b>.
                                </span>
                              )}
                            </p>
                          ) : selectedCoachStatus?.toLowerCase() ===
                            "accepted" ? (
                            <p className="d-flex align-items-baseline gap-2">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_105392)">
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    fill="#78EB7B"
                                  />
                                  <path
                                    d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                    fill="#C9F7CA"
                                  />
                                  <path
                                    d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                    stroke="#191919"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_105392">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {isOther === "0" ? (
                                <span>
                                  <b>{selectedCoachName}</b>{" "}
                                  {t("hasAcceptedYourRequest")}
                                </span>
                              ) : (
                                <span>
                                  <b>{selectedCoachName}</b>{" "}
                                  {t("hasAcceptedTheRequest")}
                                </span>
                              )}
                            </p>
                          ) : (
                            <p></p>
                          )
                        ) : (
                          <p></p>
                        )}
                        <p className="error-msg">{isCoachError}</p>
                      </div>
                    </>
                  )}
                </div>}
                {localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !==
                  "false" &&
                  false && (
                    <div className="col-md-4">
                      {isLoading ? (
                        <div
                          className="input-text position-relative"
                          style={{ marginTop: "5px" }}
                        >
                          <ShimmerScreen
                            case={"rect"}
                            width={"60%"}
                            height={"12px"}
                          />
                          <span
                            className="input__field"
                            style={{ marginTop: "5px" }}
                          >
                            <ShimmerScreen
                              case={"rect"}
                              width={"100%"}
                              height={"25px"}
                            />
                          </span>
                        </div>
                      ) : (
                        <>
                          <div
                            className={`input-text position-relative ${
                              isEdit ? "input__field_auto_cmplt" : ""
                            }`}
                          >
                            <label for="Mentor" className="input__label">
                              Mentor
                            </label>
                            <Autocomplete
                              disabled={isEdit ? false : true}
                              disablePortal
                              size="small"
                              required
                              id="combo-box-demo"
                              autoComplete
                              includeInputInList
                              openOnFocus
                              className={`${
                                mentorInput ? "has-value" : "has-no-value"
                              }`}
                              options={
                                mentorInput !== undefined &&
                                mentorInput?.length >= 2
                                  ? users
                                  : [
                                      {
                                        label: t("typeAtLeast3Char"),
                                        value: "",
                                        showValue: t("typeAtLeast3Char"),
                                      },
                                    ]
                              }
                              sx={{ width: "100%" }}
                              onChange={(event, value) => {
                                // console.log('value', value)
                                // if (
                                //     value.value === teamLead ||
                                //     value.value === coach ||
                                //     value.value === requestedTeamLeadId ||
                                //     value.value === requestedCoachId
                                // ) {
                                //     setIsMentorError(
                                //         "Please select different user from team lead and coach."
                                //     );
                                //     setMentor("");
                                //     setMentorInput("");
                                // } else {
                                if (_.isEmpty(value)) {
                                } else {
                                  setIsMentorError("");
                                  setMentor(value.value);
                                  setMentorInput(value.showValue);
                                }
                                // }
                              }}
                              onInputChange={(e) => {
                                setCurrentRole(2);
                                if (e !== null) {
                                  // console.log('eMentor', e.target.value)
                                  setMentorInput(e.target.value);
                                  // dispatch(selectedMentor(e.target.value))
                                  setMentor(e.target.value);
                                  if (e.target.value?.length > 2) {
                                    getSearchResult(
                                      e.target.value.trim(),
                                      "mentor"
                                    );
                                  } else {
                                    setUsers([]);
                                  }
                                }
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label={t("")} />
                              )}
                              value={mentorInput}
                            />
                          </div>

                          <div className="statusshowsec">
                            {!_.isEmpty(selectedMentorStatus) ? (
                              selectedMentorStatus?.toLowerCase() ===
                              "reject" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_34_20919)">
                                      <path
                                        d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                        fill="#F57C7C"
                                      />
                                      <path
                                        d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                        fill="#FFCACA"
                                      />
                                      <path
                                        d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                        fill="black"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_34_20919">
                                        <rect
                                          width="13.988"
                                          height="14"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>{" "}
                                  {isOther === "0" ? (
                                    <span>
                                      <b>{selectedMentorName}</b>{" "}
                                      {t("hasRejectedYourRequest")}{" "}
                                      {rejectReasonMentor && (
                                        <>
                                          <b> {t("reason")}: </b>{" "}
                                          {rejectReasonMentor}
                                        </>
                                      )}
                                    </span>
                                  ) : (
                                    <span>
                                      <b>{selectedMentorName}</b>{" "}
                                      {t("hasRejectedTheRequest")}{" "}
                                      {rejectReasonMentor && (
                                        <>
                                          <b> {t("reason")}: </b>{" "}
                                          {rejectReasonMentor}
                                        </>
                                      )}
                                    </span>
                                  )}
                                </p>
                              ) : selectedMentorStatus?.toLowerCase() ===
                                "pending" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1907_105419)">
                                      <path
                                        d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                        fill="#FAA16F"
                                      />
                                      <path
                                        d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                        fill="#FFDDCA"
                                      />
                                      <path
                                        d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                        fill="black"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1907_105419">
                                        <rect
                                          width="13.988"
                                          height="14"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  {isOther === "0" ? (
                                    <span>
                                      {t("yourRequestIsPendingWith")}{" "}
                                      <b>{selectedMentorName}</b>.
                                    </span>
                                  ) : (
                                    <span>
                                      {t("requestIsPendingWith")}{" "}
                                      <b>{selectedMentorName}</b>.
                                    </span>
                                  )}
                                </p>
                              ) : selectedMentorStatus?.toLowerCase() ===
                                "accepted" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1907_105392)">
                                      <path
                                        d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                        fill="#78EB7B"
                                      />
                                      <path
                                        d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                        fill="#C9F7CA"
                                      />
                                      <path
                                        d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                        stroke="#191919"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                        stroke="#191919"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1907_105392">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>{" "}
                                  {isOther === "0" ? (
                                    <span>
                                      <b>{selectedMentorName}</b>{" "}
                                      {t("hasAcceptedYourRequest")}
                                    </span>
                                  ) : (
                                    <span>
                                      <b>{selectedMentorName}</b>{" "}
                                      {t("hasAcceptedTheRequest")}
                                    </span>
                                  )}
                                </p>
                              ) : (
                                <p></p>
                              )
                            ) : (
                              <p></p>
                            )}
                          </div>
                          <p className="error-msg">{isMentorError}</p>
                        </>
                      )}
                    </div>
                  )}
                {localStorage.getItem(SessionKeys.SHOW_MENTER_COACH) !==
                  "false" &&
                  false && (
                    <div className="col-md-4">
                      {isLoading ? (
                        <div
                          className="input-text position-relative"
                          style={{ marginTop: "5px" }}
                        >
                          <ShimmerScreen
                            case={"rect"}
                            width={"60%"}
                            height={"12px"}
                          />
                          <span
                            className="input__field"
                            style={{ marginTop: "5px" }}
                          >
                            <ShimmerScreen
                              case={"rect"}
                              width={"100%"}
                              height={"25px"}
                            />
                          </span>
                        </div>
                      ) : (
                        <>
                          <div
                            className={`input-text position-relative ${
                              isEdit ? "input__field_auto_cmplt" : ""
                            }`}
                          >
                            <label for="teamLead" className="input__label">
                              Team Lead
                            </label>
                            <Autocomplete
                              disablePortal
                              disabled={isEdit ? false : true}
                              size="small"
                              id="combo-box-demo"
                              autoComplete
                              includeInputInList
                              className={`${
                                teamLeadInput ? "has-value" : "has-no-value"
                              }`}
                              // renderOption={option=> {console.log('option',option)}}
                              options={
                                teamLeadInput !== undefined &&
                                teamLeadInput?.length >= 2
                                  ? users
                                  : [
                                      {
                                        label: t("typeAtLeast3Char"),
                                        value: "",
                                        showValue: t("typeAtLeast3Char"),
                                      },
                                    ]
                              }
                              sx={{ width: "100%" }}
                              onChange={(event, value) => {
                                // console.log("selectedValue ", value)
                                // if (
                                //     value.value === mentor ||
                                //     // value.value === coach ||
                                //     value.value === requestedMentorId
                                //     //|| value.value === requestedCoachId
                                // ) {
                                //     setIsTeamLeadError(
                                //         "Please select different user for team lead and mentor."
                                //     );
                                //     setTeamLead("");
                                //     setTeamLeadInput("");
                                // } else {
                                if (!_.isEmpty(value)) {
                                  setIsTeamLeadError("");
                                  setTeamLead(value.value);
                                  setTeamLeadInput(value.showValue);
                                }
                              }}
                              onInputChange={(e) => {
                                setCurrentRole(3);
                                if (e !== null) {
                                  setTeamLeadInput(e.target.value);
                                  setTeamLead(e.target.value);
                                  // dispatch(selectedTeamLead(e.target.value))
                                  if (e.target.value?.length > 2) {
                                    getSearchResult(
                                      e.target.value.trim(),
                                      "team_lead"
                                    );
                                  } else {
                                    setUsers([]);
                                  }
                                }
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label={t("")} />
                              )}
                              value={teamLeadInput}
                            />
                          </div>

                          <div className="statusshowsec">
                            {!_.isEmpty(selectedTeamLeadStatus) ? (
                              selectedTeamLeadStatus?.toLowerCase() ===
                              "reject" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_34_20919)">
                                      <path
                                        d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                        fill="#F57C7C"
                                      />
                                      <path
                                        d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                        fill="#FFCACA"
                                      />
                                      <path
                                        d="M7 0C8.93297 0 10.683 0.783512 11.9498 2.05033C13.2166 3.31702 14.0001 5.06714 14.0001 7C14.0001 8.93309 13.2166 10.683 11.9498 11.9497C10.683 13.2165 8.93297 14 7 14C5.06702 14 3.31702 13.2165 2.05033 11.9497C0.783512 10.683 0 8.93298 0 6.99989C0 5.06702 0.783512 3.31691 2.05033 2.05021C3.31702 0.783512 5.06702 0 7 0ZM9.13281 4.25754C9.28104 4.1092 9.52155 4.1092 9.66978 4.25754C9.818 4.40576 9.818 4.64616 9.66978 4.7945L7.46393 7.00046L9.66978 9.20641C9.818 9.35464 9.818 9.59504 9.66978 9.74338C9.52155 9.8916 9.28104 9.8916 9.13281 9.74338L6.92686 7.53742L4.7209 9.74349C4.57267 9.89172 4.33216 9.89172 4.18394 9.74349C4.03571 9.59515 4.03571 9.35475 4.18394 9.20653L6.39001 7.00057L4.18394 4.7945C4.03571 4.64616 4.03571 4.40576 4.18394 4.25754C4.33216 4.1092 4.57267 4.1092 4.7209 4.25754L6.92697 6.46349L9.13281 4.25754ZM11.4128 2.58717C10.2835 1.45788 8.72334 0.759473 7 0.759473C5.27666 0.759473 3.71659 1.45788 2.58729 2.58717C1.45799 3.71647 0.759473 5.27666 0.759473 6.99989C0.759473 8.72323 1.45799 10.2834 2.58717 11.4127C3.71647 12.5419 5.27655 13.2404 6.99989 13.2404C8.72323 13.2404 10.2834 12.5419 11.4127 11.4127C12.542 10.2834 13.2405 8.72323 13.2405 6.99989C13.2406 5.27666 12.5421 3.71647 11.4128 2.58717Z"
                                        fill="black"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_34_20919">
                                        <rect
                                          width="13.988"
                                          height="14"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>{" "}
                                  {isOther === "0" ? (
                                    <span>
                                      <b>{selectedTeamLeadName}</b>{" "}
                                      {t("hasRejectedYourRequest")}{" "}
                                      {rejectReasonTeamLead && (
                                        <>
                                          <b> {t("reason")}: </b>{" "}
                                          {rejectReasonTeamLead}
                                        </>
                                      )}
                                    </span>
                                  ) : (
                                    <span>
                                      <b>{selectedTeamLeadName}</b>{" "}
                                      {t("hasRejectedTheRequest")}{" "}
                                      {rejectReasonTeamLead && (
                                        <>
                                          <b> {t("reason")}: </b>{" "}
                                          {rejectReasonTeamLead}
                                        </>
                                      )}
                                    </span>
                                  )}
                                </p>
                              ) : selectedTeamLeadStatus?.toLowerCase() ===
                                "pending" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1907_105419)">
                                      <path
                                        d="M7 14C10.8658 14 14 10.8658 14 7C14 3.13417 10.8658 0 7 0C3.13417 0 0 3.13417 0 7C0 10.8658 3.13417 14 7 14Z"
                                        fill="#FAA16F"
                                      />
                                      <path
                                        d="M7 14C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.1705 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0V14Z"
                                        fill="#FFDDCA"
                                      />
                                      <path
                                        d="M5.92331 4.26033C5.92331 3.9609 6.16591 3.7183 6.46534 3.7183C6.7645 3.7183 7.0071 3.9609 7.0071 4.26033V7.55926L9.26512 8.5518C9.5386 8.67229 9.66291 8.99166 9.54243 9.26514C9.42194 9.53888 9.10257 9.66292 8.82909 9.54244L6.27465 8.41957C6.06947 8.34253 5.92331 8.14446 5.92331 7.91224V4.26033ZM0.253533 4.19449C0.23878 4.14313 0.230857 4.08876 0.230857 4.03276L0.235228 2.02718C0.235228 1.7037 0.49723 1.4417 0.820702 1.4417C1.1439 1.4417 1.40618 1.7037 1.40618 2.02718L1.40454 2.78832C1.75269 2.32524 2.15724 1.90738 2.60881 1.54443C3.06725 1.17642 3.5806 0.860327 4.14367 0.608981C5.90856 -0.178116 7.82371 -0.175931 9.4938 0.46391C11.1513 1.09883 12.569 2.36185 13.3599 4.10434C13.3752 4.13193 13.388 4.16089 13.3984 4.19094C14.1658 5.94354 14.1587 7.84093 13.5241 9.49681C12.914 11.0893 11.7245 12.46 10.0872 13.2665C10.0768 13.2725 10.0664 13.2779 10.0555 13.2834C9.71564 13.4511 9.35993 13.591 8.99711 13.7014C8.8616 13.7413 8.72063 13.7284 8.59605 13.6615C8.18352 13.4394 8.24471 12.8293 8.69249 12.693C8.93236 12.6192 9.16568 12.5326 9.3938 12.4307C9.405 12.425 9.41675 12.4198 9.4285 12.4149C9.48314 12.39 9.53751 12.3643 9.59133 12.3378C9.60581 12.3307 9.62056 12.3242 9.63559 12.3184C11.0185 11.6327 12.0239 10.4713 12.5408 9.12252C13.0853 7.70078 13.0883 6.07249 12.4203 4.57479L12.4201 4.57424C11.7518 3.07655 10.5393 1.99139 9.11923 1.44744C7.69749 0.902674 6.06947 0.899942 4.57177 1.56792C4.10456 1.77586 3.6661 2.04316 3.26723 2.36322C2.88036 2.67404 2.53422 3.03239 2.23698 3.4298L2.70416 3.4033C3.02736 3.38554 3.30411 3.63333 3.32187 3.95681C3.33963 4.28001 3.09184 4.55676 2.76836 4.57452L0.863868 4.68216C0.562799 4.69855 0.302163 4.48518 0.253533 4.19449ZM6.74647 13.9997C7.22594 14.0148 7.47565 13.4383 7.13606 13.0987C7.03852 13.0045 6.92023 12.9526 6.78472 12.9468C6.45906 12.9362 6.14324 12.8998 5.82332 12.8373C5.61787 12.7979 5.41788 12.8766 5.29358 13.0446C5.07092 13.3577 5.23976 13.794 5.61732 13.8702C5.98957 13.9439 6.3672 13.9872 6.74647 13.9997ZM3.49208 13.0648C3.81309 13.2503 4.21716 13.0627 4.27918 12.696C4.31278 12.4783 4.21525 12.2698 4.02619 12.1567C3.74561 11.9931 3.48443 11.8095 3.23417 11.6027C2.85825 11.2928 2.30091 11.6114 2.37741 12.0931C2.39954 12.2215 2.46074 12.3277 2.56018 12.4122C2.85251 12.6547 3.16418 12.873 3.49208 13.0648ZM1.06959 10.7066C1.31219 11.092 1.89384 11.0117 2.02252 10.5743C2.06377 10.4279 2.04328 10.2784 1.96324 10.1489C1.79139 9.87492 1.64359 9.58833 1.51764 9.29027C1.34826 8.88757 0.788191 8.85397 0.573453 9.23454C0.493132 9.37524 0.483296 9.54817 0.546133 9.69734C0.69257 10.0462 0.868512 10.3861 1.06959 10.7066ZM0.0180322 7.49123C0.0349708 7.727 0.204083 7.92043 0.435213 7.96961C0.780541 8.03873 1.09063 7.76853 1.06877 7.41692C1.04555 7.09263 1.04883 6.7738 1.07751 6.44978C1.09363 6.25745 1.00948 6.07659 0.850481 5.96703C0.516627 5.74164 0.0666623 5.95337 0.0286871 6.35416C-0.00559383 6.73227 -0.00915714 7.11254 0.0180322 7.49123Z"
                                        fill="black"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1907_105419">
                                        <rect
                                          width="13.988"
                                          height="14"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>

                                  {isOther === "0" ? (
                                    <span>
                                      {t("yourRequestIsPendingWith")}{" "}
                                      <b>{selectedTeamLeadName}</b>.
                                    </span>
                                  ) : (
                                    <span>
                                      {t("requestIsPendingWith")}{" "}
                                      <b>{selectedTeamLeadName}</b>.
                                    </span>
                                  )}
                                </p>
                              ) : selectedTeamLeadStatus?.toLowerCase() ===
                                "accepted" ? (
                                <p className=" d-flex align-items-baseline gap-2">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1907_105392)">
                                      <path
                                        d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                        fill="#78EB7B"
                                      />
                                      <path
                                        d="M7.99935 14.7077C7.1184 14.7077 6.24607 14.5342 5.43218 14.197C4.61829 13.8599 3.87877 13.3658 3.25584 12.7429C2.63291 12.1199 2.13878 11.3804 1.80166 10.5665C1.46453 9.75263 1.29102 8.8803 1.29102 7.99935C1.29102 7.1184 1.46453 6.24607 1.80166 5.43218C2.13878 4.61829 2.63291 3.87877 3.25584 3.25584C3.87877 2.63291 4.61829 2.13878 5.43218 1.80166C6.24607 1.46453 7.1184 1.29102 7.99935 1.29102V14.7077Z"
                                        fill="#C9F7CA"
                                      />
                                      <path
                                        d="M7.99935 14.7077C11.7041 14.7077 14.7077 11.7041 14.7077 7.99935C14.7077 4.2946 11.7041 1.29102 7.99935 1.29102C4.2946 1.29102 1.29102 4.2946 1.29102 7.99935C1.29102 11.7041 4.2946 14.7077 7.99935 14.7077Z"
                                        stroke="#191919"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M11.5 5.08203L7.41667 10.6237L4.5 8.29036"
                                        stroke="#191919"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1907_105392">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>{" "}
                                  {isOther === "0" ? (
                                    <span>
                                      <b>{selectedTeamLeadName}</b>{" "}
                                      {t("hasAcceptedYourRequest")}
                                    </span>
                                  ) : (
                                    <span>
                                      <b>{selectedTeamLeadName}</b>{" "}
                                      {t("hasAcceptedTheRequest")}
                                    </span>
                                  )}
                                </p>
                              ) : (
                                <p></p>
                              )
                            ) : (
                              <p></p>
                            )}
                          </div>
                          <p className="error-msg">{isTeamLeadError}</p>
                        </>
                      )}
                    </div>
                  )}
              </div>

              <div className="row mt-1 edit_profile_input nffgh">
                {isLoading ? (
                  <label className="infoedit">
                    <ShimmerScreen
                      case={"rect"}
                      width={"50%"}
                      height={"2rem"}
                    />
                  </label>
                ) : (
                  <label className="infoedit">
                    <i>{t("forMoreInforAboutRole")}</i>
                  </label>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {isOther === "1" || true? (
            ""
          ) : (
            <div className="row mt-3">
              <div className={`col-md-12 mb-3 ${!isEdit ? "mt-3s" : ""}`}>
                <div
                  className={`edit_btn ${
                    isEdit ? "d-flex justify-content-end gap-4" : ""
                  }`}
                >
                  {isLoading ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"40px"}
                      width={"20%"}
                    />
                  ) : (
                    <button
                      className="btn-primary"
                      onClick={() => {
                        setIsCoachError("");
                        setIsMentorError("");
                        setIsTeamLeadError("");
                        setIsTimezoneError("");
                        setLinkedProfilLinkError("");
                        setXProfilLinkError("");
                        if (isEdit) {
                          clickStreamUser("save_profile_btn_click", {
                            user_id: authBroker?.payload?.user?.user_id,
                          });
                          userProfileUpdate();
                        } else {
                          clickStreamUser("edit_profile_btn_click", {
                            user_id: authBroker?.payload?.user?.user_id,
                          });
                          setIsEdit(true);
                        }
                      }}
                    >
                      {isEdit ? t("save") : t("editProfile")}
                    </button>
                  )}
                  {isLoading && isEdit ? (
                    <ShimmerScreen
                      case={"rect"}
                      height={"40px"}
                      width={"20%"}
                    />
                  ) : isEdit ? (
                    <button
                      className="btn-primary"
                      onClick={() => {
                        clickStreamUser("cancel_edit_profile_btn_click", {
                          user_id: authBroker?.payload?.user?.user_id,
                        });
                        setIsEdit(false);
                      }}
                    >
                      {t("cancel")}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}

          <ConfirmModal
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={showModalMsg}
            isConfirm={isConfirm}
            isRightIcon={true}
          />

          <SimplePopup
            confirmModal={showLimitPopup}
            setConfirmModal={setShowLimitPopup}
            showModalMsg={error}
            isRightIcon={false}
          />
        </div>
      </section>
    </>
  );
};
export default ProfilEdit;
